export default "__VITE_ASSET__CHfWzlWw__"